import { render, staticRenderFns } from "./word-language-panel.vue?vue&type=template&id=704908a2&"
import script from "./word-language-panel.vue?vue&type=script&lang=js&"
export * from "./word-language-panel.vue?vue&type=script&lang=js&"
import style0 from "./word-language-panel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\uds\\projects\\alpheios\\components\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('704908a2', component.options)
    } else {
      api.reload('704908a2', component.options)
    }
    module.hot.accept("./word-language-panel.vue?vue&type=template&id=704908a2&", function () {
      api.rerender('704908a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/word-list/word-language-panel.vue"
export default component.exports